import { SearchState } from "react-instantsearch-core"
import { IntlShape } from "react-intl"

import { AllCategories } from "~/hooks/useCategories"
import {
  addHashToUrl,
  getCategoriesTreePart,
  getDietPart,
  getDifficultyPart,
  getIngredientsPart,
  getTypePart,
  getVerticalPart,
  parseHash,
} from "~/templates/Category/utils/urlUtils"

const createSearchURL = (
  state: SearchState,
  CATEGORIES: AllCategories,
  baseSlug: string
) => {
  let url = "/" + baseSlug + "/"
  const hashPart = []

  if (state.query) {
    url += "?q=" + state.query
  }

  const { hashPart: verticalPart } = getVerticalPart(state)
  hashPart.push(verticalPart)

  const { hashPart: ingredientsPart } = getIngredientsPart(state)
  hashPart.push(ingredientsPart)

  const { hashPart: categoriesPart } = getCategoriesTreePart(state, CATEGORIES)
  hashPart.push(categoriesPart)

  const { hashPart: typePart } = getTypePart(state)
  hashPart.push(typePart)

  const { hashPart: difficultyPart } = getDifficultyPart(state)
  hashPart.push(difficultyPart)

  const { hashPart: dietPart } = getDietPart(state)
  hashPart.push(dietPart)

  return url ? `${addHashToUrl(url, hashPart)}` : ""
}

function searchStateToSearchUrl(
  searchState: SearchState,
  CATEGORIES: AllCategories,
  intl: IntlShape
) {
  const baseUrl = intl.formatMessage({ id: "path:search" })
  if (searchState) {
    return createSearchURL(searchState, CATEGORIES, baseUrl)
  } else {
    return `/${baseUrl}/`
  }
}

const searchUrlToSearchState = (
  search: string,
  pathname: string,
  hash: string,
  CATEGORIES: AllCategories
) => {
  let searchState: any = {}

  const urlParams = new URLSearchParams(search)
  const keywordParam = urlParams.get("q")

  if (keywordParam) {
    searchState = {
      ...searchState,
      query: keywordParam,
    }
  }

  if (hash) {
    searchState = parseHash(hash, CATEGORIES, searchState)
  }

  return searchState
}

const getQueriedSearchURL = (lang: string, intl: IntlShape) => {
  if (typeof window === "undefined") return null

  const { origin } = location
  const urlParams = new URLSearchParams(location.search)
  const keyword = urlParams.get("q")?.toLowerCase()

  // Using "origin" instead of "siteUrl" for this to work in staging (where urls never equate to "https://www.chefclub.tv")
  return (
    keyword &&
    `${origin}/${lang}/${intl.formatMessage({
      id: "path:search",
    })}/?q=${keyword}`
  )
}

export {
  createSearchURL,
  getQueriedSearchURL,
  searchStateToSearchUrl,
  searchUrlToSearchState,
}
